import { StyleSheet } from "../../react-native-components";

const styles = StyleSheet.create({
    container: {
        backgroundColor: '#fff',
        borderRadius: 8,
        padding: 16,
    },
    tabsContainer: {
        flexDirection: 'row',
        paddingBottom: 20

    },
    mainChartContainer: {
        borderWidth: 1,
        borderColor: 'rgb(221, 225, 229)',
        padding: 20
    },


    tabItemContainer: {
        padding: 12,
        borderRadius: 16,
        marginRight: 10,
        flex: 1,
        minWidth: 240,
        boxShadow: "rgba(0, 0, 0, 0.25) 0px 2px 4px",
        backgroundColor: "rgb(248, 249, 250)",
        height: 120,
    },
    activeContainer: {
        borderColor: "#5961C7",
        borderWidth: 1
    },
    content: {
        // flex: 1,
        // width: "fit-content"
    },
    label: {
        color: '#333',
        textWrap: "nowrap"
    },
    value: {
        color: '#000',
        marginBottom: 4
    },
    subInfo: {
        flexDirection: 'row',
        alignItems: 'center'
    },
    badge: {
        paddingHorizontal: 6,
        paddingVertical: 2,
        borderRadius: 4,
        marginRight: 6
    },
    subValue: {
        fontSize: 10,
        fontWeight: '600',
        color: '#666'
    },
    subLabel: {
        fontSize: 10,
        color: '#888'
    },
    chartContainer: {
        flex: 1,
        marginLeft: 10
    }







})

export default styles